const DEFAULT_BASE = "https://api.bookatherapy.com/api";

const normalizeBase = (url) => {
  if (!url) return DEFAULT_BASE;
  return url.endsWith("/") ? url.slice(0, -1) : url;
};

export const API = normalizeBase(
  `${process.env.REACT_APP_API_BASE_URL}` || "https://api.bookatherapy.com/api",
);
export const API_BASE_URL = API || DEFAULT_BASE;
export const DEFAULT_CLINIC_ID = process.env.REACT_APP_CLINIC_ID || "";
export const DEV_SKIP_AUTH = process.env.REACT_APP_DEV_SKIP_AUTH === "false";
